
import { Directive, Input, ElementRef } from '@angular/core';
import {
  NG_VALIDATORS,
  Validator,
  AbstractControl,
  ValidationErrors
} from '@angular/forms';
import { Static } from '@app/shared/util/static';

export interface SeparationPrefix {
  thousandsSeparator: string;
  decimalSeparator: string;
}

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[formatNumber]',
  providers: [{ provide: NG_VALIDATORS, useExisting: FormatNumberDirective, multi: true }]
})
export class FormatNumberDirective implements Validator {

  // Parametro de entrada principal
  @Input('formatNumber') formatNumber: SeparationPrefix;

  /**
   * Aplica la validacion del valor minimo
   *
   * @param {AbstractControl} c
   * @returns {{ [key: string]: any }}
   * @memberof CustomMinEqualDirective
   */
  validate(c: AbstractControl): ValidationErrors {
    let val = c.value;
    val = Static.numberFormatWithoutThousandsSeparator(
      val,
      this.formatNumber.thousandsSeparator,
      this.formatNumber.decimalSeparator
    );
    if (isNaN(val)) {
      return { 'format': true };
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/format-number.directive.ts